import { CEReportAttributesBase } from './ce-report-attributes-base'


export class CEReportAttributes extends CEReportAttributesBase {

}